import { useState } from 'react';
import ClustersComponent from '../../components/clusters/ClustersComponent';
import MolstarComponent from '../../components/molstar/MolstarComponent';
import PlotsComponent from '../../components/plots/PlotsComponent';
import { QueryResult } from '../../models/QueryResult';

enum VisualizationType {
   MOLSTAR,
   PLOTS,
   CLUSTERS,
}

interface VisualizationWindowProps {
   query: QueryResult;
}

const VisualizationWindow = (props: VisualizationWindowProps): React.JSX.Element => {
   const [activeTab, setActiveTab] = useState<VisualizationType>(VisualizationType.MOLSTAR);
   const activateTab = (clickedTab: VisualizationType): void => {
      if (activeTab === clickedTab) {
         return;
      }
      setActiveTab(clickedTab);
   };

   return (
      <>
         <div className="tab-nav">
            <button
               className={`tab-button ${activeTab === VisualizationType.MOLSTAR ? 'active' : ''}`}
               onClick={(): void => activateTab(VisualizationType.MOLSTAR)}
            >
               3D Structure
            </button>
            <button
               className={`tab-button ${activeTab === VisualizationType.PLOTS ? 'active' : ''}`}
               onClick={(): void => activateTab(VisualizationType.PLOTS)}
            >
               Statistics / Plots
            </button>
            <button
               className={`tab-button ${activeTab === VisualizationType.CLUSTERS ? 'active' : ''}`}
               onClick={(): void => activateTab(VisualizationType.CLUSTERS)}
            >
               Clusters
            </button>
         </div>
         {activeTab === VisualizationType.MOLSTAR && (
            <div id="molstar-tab" className="tab-content active">
               <MolstarComponent />
            </div>
         )}
         {activeTab === VisualizationType.PLOTS && (
            <div id="plots-tab" className="tab-content active">
               <PlotsComponent plots={props.query.plots} />
            </div>
         )}
         {activeTab === VisualizationType.CLUSTERS && (
            <div id="clusters-tab" className="tab-content active">
               <ClustersComponent query={props.query} />
            </div>
         )}
      </>
   );
};

export default VisualizationWindow;
